import { RFSData, useRFS as useRFSQuery } from "@/api/rfs";
import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { Loading } from "@/components/ui/loading";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { Suspense, lazy } from "react";
import { useLocation, useParams } from "react-router-dom";
import { H2 } from "@/components/ui/typography";

const GPONCreateForm = lazy(() => import("@/features/gpon/GPONCreateForm"));
interface GPONCreateProps {
  useRFS?: (
    queryKey: { id: string },
    options?: { staleTime?: number },
  ) => { data?: RFSData; isPending: boolean };
}
export function GPONCreate({ useRFS = useRFSQuery }: GPONCreateProps) {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: rfs } = useRFS({ id }, { staleTime: Infinity });
  const { state } = useLocation();

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "RFS",
          },
          {
            href: "/rfs/rfs",
            label: "RFS List",
          },
          {
            href: state?.from ? state.from : `/rfs/rfs/${id}`,
            label: "Detail",
          },
          {
            href: `/rfs/rfs/${id}/gpon/create`,
            label: "Create GPON",
          },
        ]}
      />
      <H2>GPON - {rfs?.clusterId}</H2>
      <Suspense fallback={<Loading />}>
        <GPONCreateForm />
      </Suspense>
    </>
  );
}
